<template>
  <div>
    <Header />

    <!-- Start Main Content Area -->
    <div class="main-content">
      <!-- Start Sidebar for Filters -->
      <aside class="sidebar">
        <h3>Filtros</h3>

        <!-- Filter Group: Repuesto Name -->
        <div class="filter-group">
          <h4 class="filter-title">Buscar por nombre de producto</h4>
          <input type="text" v-model="searchText" placeholder="Buscar producto..." class="search-input" />
        </div>

        <!-- Filter Group: Repuesto Name -->
        <div class="filter-group">
          <h4 class="filter-title">Buscar por modelo de batería</h4>
          <input type="text" placeholder="Buscar modelo..." class="search-input" />
        </div>

        <!-- Filter Group: Repuesto Name -->
        <div class="filter-group">
          <h4 class="filter-title">Buscar por marca</h4>
          <input type="text" placeholder="Buscar marca..." class="search-input" />
        </div>

        <!-- Filter Group: Price Range -->
        <div class="filter-group">
          <h4 class="filter-title">Rango de Precio</h4>
          <div class="price-range-container">
            <input type="range" min="0" max="500" value="300" class="price-range" />
            <div class="price-range-values">
              <span>$0</span> - <span>$500</span>
            </div>
          </div>
        </div>

      </aside>
      <!-- End Sidebar for Filters -->

      <!-- Start Trending Product Area -->
      <section class="trending-product section">
        <div class="container">
          <div class="row">
            <!-- Mostrar mensaje de cargando -->
            <div v-if="isLoading" class="loading-overlay">Cargando...</div>

            <!-- Mostrar mensaje de no resultados -->
            <div v-else-if="productosFiltrados.length === 0" class="no-results-message">No hay resultados relacionados con esta busqueda</div>

            <!-- Itera sobre los productos de ejemplo -->
            <div class="col-lg-3 col-md-6 col-12" v-for="producto in productosFiltrados" :key="producto.id">
              <!-- Start Single Product -->
              <div class="single-product">
                <div class="product-image">
                  <!-- Mostrar la imagen de portada o una imagen por defecto -->
                  <img :src="getImagenPortada(producto.imagenes)" alt="#" class="product-image-size" />

                                  <!-- Overlay de Confirmación -->
                <div
                  v-if="animationProductId === producto.id"
                  class="product-added-overlay"
                >
                  <div class="overlay-content">
                    <i class="lni lni-checkmark"></i>
                    <span>Producto agregado</span>
                  </div>
                </div>

                <!-- Botón Agregar al Carrito -->
                <div class="button">
                  <div v-if="animationProductId !== producto.id">
                    <button
                      @click="agregarAlCarrito(producto.id)"
                      class="btn"
                      :disabled="isProcessing"
                    >
                      <i class="lni lni-cart"></i> Agregar
                    </button>
                  </div>
                </div>
                </div>
                <div class="product-info">
                  <span class="category">{{ producto.repuesto.nombre }}</span>
                  <h4 class="title">
                    <a href="#">{{ producto.nombre }}</a>
                  </h4>
                  <div class="price">
                    <span>${{ producto.precioVenta }}</span>
                  </div>
                </div>
              </div>
              <!-- End Single Product -->
            </div>
          </div>
        </div>
      </section>
      <!-- End Trending Product Area -->
    </div>
    <!-- End Main Content Area -->

    <!-- ========================= scroll-top ========================= -->
    <a href="#" class="scroll-top">
      <i class="lni lni-chevron-up"></i>
    </a>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Swal from "sweetalert2";
import EventBus from "@/EventBus";
import { CarritoService } from "@/services/CarritoService";
import { ProductoService } from "@/services/ProductoService";
import { config } from "@/config"; // Importar la configuración

export default {
  name: "HomePage",
  components: {
    Header,
  },
  data() {
    return {
      searchText: "",
      isLoading: false,
      animationProductId: null,
      productos: [],
      filtrosAbiertos: {
        categorias: true,
        marcas: false,
      },
    };
  },
  watch: {
    '$route.query.q': {
      handler(newQuery) {
        this.searchText = newQuery || ""; // Actualiza el texto de búsqueda
        this.buscarProductos(newQuery); // Busca productos al cambiar la query
      },
      immediate: true, // Esto ejecuta el watcher inmediatamente al montarse
    },
  },
  computed: {
    productosFiltrados() {
      return this.productos.filter(producto =>
        producto.nombre.toLowerCase().includes(this.searchText.toLowerCase())
      );
    },
  },
  methods: {
    getImagenPortada(imagenes) {
      const portada = imagenes.find((imagen) => imagen.portada);
      if (!portada) return require("@/assets/paquete.png");
      return portada.imagen.startsWith('http') ? portada.imagen : `${config.API_URL}${portada.imagen}`;
    },
    isValidToken() {
      const token = localStorage.getItem("accessToken");
      if (!token) return false;
      const parts = token.split(".");
      return parts.length === 3;
    },
    async agregarAlCarrito(productoId) {
      let accessToken = localStorage.getItem("accessToken");

      if (!this.isValidToken()) {
        localStorage.removeItem("accessToken");
        accessToken = null;
      }

      if (!accessToken) {
        Swal.fire({
          title: "Necesitas iniciar sesión",
          text: "Para agregar productos al carrito, primero debes iniciar sesión.",
          icon: "warning",
          confirmButtonText: "Iniciar sesión",
          customClass: {
            confirmButton: "swal-button--confirm-custom",
          },
        }).then((result) => {
          if (result.isConfirmed) {
            // Redirige al usuario a la página de inicio de sesión si confirma
            this.$router.push("/login");
          }
        });
        return;
      }
      // Verifica si ya se está procesando otra solicitud
      if (this.isProcessing) return;

      try {
        this.isProcessing = true; // Inicia el procesamiento

        const response = await CarritoService.addDetalle({
          productoID: productoId,
          cantidad: 1,
        });

        if (response.exito) {
          // Activa la animación para el producto actual
          this.animationProductId = productoId;

          // Después de 2 segundos, ocultar el overlay y mostrar el botón nuevamente
          setTimeout(() => {
            this.animationProductId = null;
            this.isProcessing = false; // Finaliza el procesamiento
          }, 1000); // Duración de la animación

          EventBus.emit("cartUpdated");
        } else {
          this.isProcessing = false; // Finaliza el procesamiento en caso de error
          Swal.fire({
            title: "Error",
            text: `Error: ${response.errores}`,
            icon: "error",
            customClass: {
              confirmButton: "swal-button--confirm-custom",
            },
          });
        }
      } catch (error) {
        this.isProcessing = false; // Finaliza el procesamiento en caso de excepción
        console.error("Error al agregar el producto al carrito:", error);
        Swal.fire({
          title: "Error",
          text: "Error al agregar el producto al carrito",
          icon: "error",
          customClass: {
            confirmButton: "swal-button--confirm-custom",
          },
        });
      }
    },
    async buscarProductos(searchText) {
      this.isLoading = true; // Comienza la carga
      try {
        this.productos = [];
        const filteredProducts = await ProductoService.getProductosSearch(searchText);
        this.productos = filteredProducts.datos;
      } catch (error) {
        console.error('Error al buscar productos:', error);
      } finally {
        this.isLoading = false; // Finaliza la carga
      }
    },
  },
  mounted() {
    const searchText = this.$route.query.q;
    this.buscarProductos(searchText);
  }
}
</script>

<style scoped>
.no-results-message {
  display: flex; /* Flex para centrar el contenido */
  justify-content: center;
  align-items: center;
  height: 100%; /* Cambiar a 100% para ocupar todo el contenedor */
  font-size: 24px; /* Tamaño de fuente más grande */
  color: #888; /* Color gris */
  text-align: center; /* Centrar texto */
  font-weight: bold; /* Negrita para mayor énfasis */
  margin-top: 50px; /* Espacio superior para separar del resto */
  flex: 1; /* Permitir que el mensaje ocupe el espacio restante */
}



.product-image-size {
  width: 100%;
  height: 200px;
  object-fit: cover;
  position: relative;
  border-radius: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.main-content {
  display: flex;
  gap: 20px;
}

.sidebar {
  width: 280px;
  padding: 20px;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

h3 {
  font-size: 24px;
  color: #333;
  margin-bottom: 20px;
  font-weight: 600;
}

.filter-group {
  margin-bottom: 30px;
}

.filter-title {
  font-size: 18px;
  color: #555;
  margin-bottom: 15px;
  font-weight: 500;
}

.search-input {
  width: 100%;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #ddd;
  font-size: 16px;
  transition: border-color 0.3s;
}

.search-input:focus {
  outline: none;
  border-color: #007bff;
}

.price-range-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.price-range {
  width: 100%;
  margin-bottom: 10px;
}

.price-range-values {
  font-size: 16px;
  color: #555;
}

.single-product {
  background-color: #fff;
  padding: 15px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  min-width: 230px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.single-product:hover {
  transform: translateY(-10px);
}

.btn {
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 10px 15px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.3s;
}

.btn:hover {
  background-color: #0056b3;
  transform: scale(1.05);
}

.loading-overlay {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
  font-size: 18px;
  color: #007bff;
}


/* Asegúrate de que el contenedor padre tenga un tamaño adecuado */
.trending-product {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1; /* Permitir que el contenedor ocupe todo el espacio disponible */
}


.scroll-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  background-color: #007bff;
  color: white;
  border-radius: 50%;
  padding: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: background-color 0.3s, transform 0.3s;
}

.scroll-top:hover {
  background-color: #0056b3;
  transform: translateY(-3px);
}


/* Overlay de confirmación */
.product-added-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.6);
  /* Fondo oscuro semitransparente */
  color: #fff;
  font-weight: bold;
  border-radius: 5px;
  z-index: 10;
  animation: fadeInOut 1s ease-in-out;
}

.overlay-content {
  text-align: center;
}

.overlay-content i {
  font-size: 40px;
  color: #4caf50;
  /* Color del icono de confirmación */
  display: block;
  margin-bottom: 10px;
  animation: bounce 1s;
  /* Animación de rebote */
}

.overlay-content span {
  display: block;
  font-size: 16px;
}

@keyframes fadeInOut {
  0% {
    opacity: 0;
    transform: scale(0.9);
  }

  50% {
    opacity: 1;
    transform: scale(1.05);
  }

  100% {
    opacity: 0;
    transform: scale(0.9);
  }
}

@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    transform: translateY(0);
  }

  40% {
    transform: translateY(-30px);
  }

  60% {
    transform: translateY(-15px);
  }
}
</style>
